
namespace GeniuzPOS.Supplier {

    @Serenity.Decorators.registerClass()
    export class CsSupplierDialog extends Serenity.EntityDialog<CsSupplierRow, any> {
        protected getFormKey() { return CsSupplierForm.formKey; }
        protected getIdProperty() { return CsSupplierRow.idProperty; }
        protected getLocalTextPrefix() { return CsSupplierRow.localTextPrefix; }
        protected getNameProperty() { return CsSupplierRow.nameProperty; }
        protected getService() { return CsSupplierService.baseUrl; }
        protected getDeletePermission() { return CsSupplierRow.deletePermission; }
        protected getInsertPermission() { return CsSupplierRow.insertPermission; }
        protected getUpdatePermission() { return CsSupplierRow.updatePermission; }

        protected form = new CsSupplierForm(this.idPrefix);
        constructor() {
            super();
            if (!this.isNew()) {}else{
                this.form.SupplName.changeSelect2(e => {
                    var supname = Q.toId(this.form.SupplName.value);
                    var SupplierShortName = Q.toId(this.form.SupplierShortName.value);
                    var SupplRegName = Q.toId(this.form.SupplierShortName.value);
                    if (supname != null) {
                        if (SupplierShortName != null) {}else{
                        this.form.SupplierShortName.value = (this.form.SupplName.value).substring(0, 40);
                        }
                        if (SupplRegName != null) {}else{
                        this.form.SupplRegName.value = this.form.SupplName.value;
                        }
                    }
                });
                this.form.SupplAddress.changeSelect2(e => {
                    var shopadd = Q.toId(this.form.SupplAddress.value);
                    var SupplRegAddress = Q.toId(this.form.SupplRegAddress.value);
                    if (shopadd != null) {

                        if (SupplRegAddress != null) {}else{
                        this.form.SupplRegAddress.value = this.form.SupplAddress.value;
                        }

                    }
                });
               
            }
        
        this.form.ConsignFg.element.parent();
        this.form.ConsignFg.change(e => {
            var isConsignFgT =  this.ConsignFgT;
            var isConsignFgF = this.ConsignFgF;
            

            if (!isConsignFgT) {
                Serenity.EditorUtils.setReadOnly(this.form.ConsignGp, isConsignFgT);
                return this.form.ConsignGp.value = 0;
               
            }
            else if (!isConsignFgF){
             Serenity.EditorUtils.setReadOnly(this.form.ConsignGp, !isConsignFgF);
             
             
            }
         });}

        private get ConsignFgT() {
            return this.form.ConsignFg.value != true;
        }
        private get ConsignFgF() {
            return this.form.ConsignFg.value != false;
        }
        protected afterLoadEntity() {
            super.afterLoadEntity();
            
            var Supplierid = Q.tryFirst(Product.CsSkuRow.getLookup().items, x => x.SupplierId == this.entity.SupplId);
            if(Supplierid !=null){
                this.deleteButton.toggleClass('disabled', true);
             
            }

        }
        
    }
}